import gsap from "gsap";

/**
 * 確実にイベントを削除できるスクロール制御
 * @param {boolean} prevent - trueでスクロール防止、falseで解除
 */
// ハンドラーを外で定義
const touchHandler = (e) => {
    e.preventDefault();
};

const preventTouchScroll = (prevent) => {
    if (prevent) {
        document.addEventListener('touchmove', touchHandler, { passive: false });
        document.addEventListener('touchstart', touchHandler, { passive: false });
    } else {
        document.removeEventListener('touchmove', touchHandler);
        document.removeEventListener('touchstart', touchHandler);
    }
};

export const splashInit = () => {
    preventTouchScroll(true)
    let splashes = document.querySelectorAll(".splash");
    if (
        !sessionStorage.getItem("splashed") &&
        document.body.classList.contains("home")
    ) {
        splash();
    } else {
        document.body.classList.add("splashed");
        splashes.forEach((splash) => {
            splash.classList.add("splash-is-end");
        });

        setTimeout(() => {
            preventTouchScroll(false)
        }, 1000);
    }
    return () => { };
};


function splash() {
    let splashes = document.querySelectorAll(".splash");
    window.scrollTo(0, 0);
    splashes.forEach((splash) => {
        splash.classList.add("splash-is-on");
    });
    sessionStorage.setItem("splashed", true);

    const splashTl = gsap.timeline(
        {
            paused: true,
            onComplete: () => {
                setTimeout(() => {
                    document.body.classList.add("splashed");
                    splashes.forEach((splash) => {
                        splash.classList.remove("splash-is-on");
                        splash.classList.add("splash-is-end");
                    });
                    preventTouchScroll(false)
                }, 400);
            }
        }
    )

    const timeMultiple = 0.35
    const imgs = document.querySelectorAll(`.Splash__innerImgs figure,.Splash__innerImgs .dummy`)

    imgs.forEach((img, imgIndex) => {
        splashTl.to(img, {
            duration: 0,
            opacity: 1,
        }, (imgIndex + 1) * timeMultiple)

        if (imgIndex != imgs.length - 1) {
            splashTl.to(img, {
                duration: 0,
                opacity: 0,
            }, (imgIndex + 2) * timeMultiple)
        }
    })

    splashTl.play(0)
}

window.splashInit = () => {
    let splashes = document.querySelectorAll(".splash");
    window.scrollTo(0, 0);
    document.body.classList.remove("splashed");
    splashes.forEach((splash) => {
        splash.classList.remove("splash-is-on");
        splash.classList.remove("splash-is-end");
    });

    setTimeout(() => {
        splash();
    }, 300);
};

splashInit();
